<template>
  <div
    class="flex flex-row justify-between pb-10 pl-10 xl:px-140px 3xl:px-200px 4xl:px-300px"
  >
    <div
      class="flex flex-col w-200px mt-10 3xl:pt-20 3xl:w-300px 3xl:pb-20 4xl:w-420px"
    >
      <div class="flex flex-col">
        <div>
          <picture>
            <source type="image/webp" :srcset="require('@/' + webP)" />
            <source type="image/jpeg" :srcset="image" />
            <img :src="image" />
          </picture>
        </div>
      </div>
      <div class="flex flex-row flex-shrink justify-center mt-10">
        <div
          v-for="(item, index) in scrollerItems"
          v-bind:key="index"
          class="flex"
        >
          <img
            class="w-5"
            v-bind:class="index == 0 ? '' : 'ml-2'"
            :src="item.active ? selectedDot : unselectedDot"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col text-width 3xl:pt-32">
      <div class="leading-60px text-20px text-white tracking-2.4px">
        {{ $t('our_product.small_header') }}
      </div>
      <div class="text-white text-30px leading-40px mt-5 font-Foco">
        {{ $t('our_product.big_header') }}
      </div>
      <div class="mt-8">
        <scroller-text-block
          v-for="(item, index) in scrollerItems"
          v-bind:key="index"
          v-bind:active="item.active"
          v-bind:header="item.header"
          v-bind:text="item.text"
          :class="index == 0 ? 'pb-10' : 'py-10'"
          @activated="onActivated(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScrollerTextBlock from './ScrollerTextBlock.vue';

const selectedDot = require('../../../assets/dot-checked.svg');
const unselectedDot = require('../../../assets/dot-unchecked.svg');

export default {
  name: 'CustomScrollerDesktop',
  components: {
    ScrollerTextBlock,
  },
  data() {
    return {
      selectedDot,
      unselectedDot,
      publicPath: process.env.BASE_URL,
      image: this.scrollerItems[0].png,
      webP: this.scrollerItems[0].webP,
    };
  },
  props: ['scrollerItems'],
  methods: {
    onActivated(idx) {
      this.scrollerItems.forEach((elem, id) => {
        if (id === idx) {
          // eslint-disable-next-line
          elem.active = true;
          this.image = elem.png;
          this.webP = elem.webP;
        } else {
          // eslint-disable-next-line
          elem.active = false;
        }
      });
    },
  },
};
</script>

<style>
.a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
.text-width {
  width: 60%;
}
</style>
